import { render, staticRenderFns } from "./VideoRoom.vue?vue&type=template&id=3dfbf6b3&"
import script from "./VideoRoom.vue?vue&type=script&lang=ts&"
export * from "./VideoRoom.vue?vue&type=script&lang=ts&"
import style0 from "./VideoRoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports